// extracted by mini-css-extract-plugin
export default {"homePage":"Pg_A_0_homePage__dvE3N","getStarted":"Pg_A_0_getStarted__gsNWd","heading":"Pg_A_0_heading__-FaOs","getStartedButton":"Pg_A_0_getStartedButton__b2PrV"};